/**
 * RBAC v3 role definitions — frontend mirror of apps/gfgf-api/src/lib/roles.ts
 *
 * Role is read from Clerk publicMetadata via RoleContext (API auth uses `users.role`).
 */

export const ROLES = {
  VIEW_ONLY: "VIEW_ONLY",
  CAMPAIGN_MANAGER: "CAMPAIGN_MANAGER",
  MANAGER: "MANAGER",
  ORG_VIEW_ONLY: "ORG_VIEW_ONLY",
  CLIENT_ADMIN: "CLIENT_ADMIN",
  GFG_FINANCE: "GFG_FINANCE",
  GFG_STANDARD_ADMIN: "GFG_STANDARD_ADMIN",
  GFG_SUPER_ADMIN: "GFG_SUPER_ADMIN",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/** All role keys (declaration order — a list, not a ranking). Labels/levels come from /me/roles. */
export const ROLE_HIERARCHY: readonly Role[] = [
  ROLES.VIEW_ONLY,
  ROLES.CAMPAIGN_MANAGER,
  ROLES.MANAGER,
  ROLES.ORG_VIEW_ONLY,
  ROLES.CLIENT_ADMIN,
  ROLES.GFG_FINANCE,
  ROLES.GFG_STANDARD_ADMIN,
  ROLES.GFG_SUPER_ADMIN,
];

export const ALL_ROLES: readonly Role[] = ROLE_HIERARCHY;

export function isRole(value: string): value is Role {
  return (ALL_ROLES as readonly string[]).includes(value);
}

export function hasMinimumRole(userRole: Role, requiredRole: Role): boolean {
  return ROLE_HIERARCHY.indexOf(userRole) >= ROLE_HIERARCHY.indexOf(requiredRole);
}
